<template>
  <v-app  style="background-color: #e4eaee ">
    <Header :show="show" v-if="isLoggedIn && !hasLoginWarnings" @toggleDrawer="drawer = true"></Header>
    <NotificationAlert></NotificationAlert>
    <Menu  :show="show" v-if="isLoggedIn && !hasLoginWarnings && !$vuetify.breakpoint.mobile"></Menu>

    <v-main>
      <v-row no-gutters justify="center">
        <MenuMobile :show="show" v-if="isLoggedIn && !hasLoginWarnings && $vuetify.breakpoint.mobile" :drawer.sync="drawer"></MenuMobile>

        <v-col cols="12" sm="12" md="11" class="ml-sm-0 ml-md-0 ml-lg-12">
          <v-container fluid  id="back-image"  transition="slide-x-transition"
                       class="fill-height ">
            <router-view></router-view>
          </v-container>
        </v-col>
      </v-row>
    </v-main>
    <NotificationDrawer />
    <v-footer v-if="this.$router.name === 'Login'" padless height="60" style="z-index: 10 !important;">
      <v-col
        class="text-left"
        cols="12"
        style="opacity: 0.5;padding-left: 35px;"
      >
        <h5>{{ new Date().getFullYear() }} © <a style="text-decoration: none;color:gray;" target="_blank" href="https://logikoss.com/">Logikoss.</a> {{ $t('messages.allRightsReserved') }}.</h5>
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>
import NotificationAlert from '@/components/Notifications/NotificationAlert'
import { loadProgressBar } from 'axios-progress-bar'
import Header from '@/components/Header'
import Menu from '@/components/Menu'
import MenuMobile from './components/MenuMobile'
import NotificationDrawer from '@/components/Notifications/NotificationDrawer'

loadProgressBar()
export default {
  name: 'App',
  components: {
    NotificationAlert,
    NotificationDrawer,
    Header,
    Menu,
    MenuMobile
  },
  data () {
    return {
      show: {
        drawer: false
      },
      drawer: false
    }
  },
  async created () {
    this.$http.interceptors.response.use(undefined, err => {
      return new Promise(() => {
        if (
          err.response &&
          err.response.status === 401 &&
          !err.config.__isRetryRequest
        ) {
          if (
            // Except if you are doing login or logout
            err.request.responseURL.includes('/login') === false &&
            err.request.responseURL.includes('/logout') === false
          ) {
            this.$store
              .dispatch('logout')
              .then(() => {
                this.$router.push({ name: 'Login' })
              })
              .catch(() => {
                this.$router.push({ name: 'Login' })
              })
          }
        }
        if (err.response && err.response.status === 420) {
          this.$router.push({ name: 'ChangePassword' })
        }
        throw err
      })
    })
  },
  computed: {
    isLoggedIn () {
      return this.$store.getters.isLoggedIn
    },
    userLogged () {
      return this.$store.getters.userLogged
    },
    hasLoginWarnings () {
      return this.$store.getters.hasLoginWarnings
    },
    loginWarnings () {
      return this.$store.getters.loginWarnings
    }
  }
}
</script>
<style lang="scss">
/*.image-back {
  background: url(./assets/images-v2/backgrounds/04.png)  center center/ cover no-repeat rgb(228, 234, 238);
  background-blend-mode: soft-light;
  background: red;
}*/
</style>
